import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import LoginPage from "@/views/pages/login.vue";
import Layout from "@/views/layouts/common/qMaster.vue";
import MenuListPage from "@/views/pages/menu/menuList.vue";
import RecommendationsPage from "@/views/pages/recommendation/index.vue";
import OrderHistoriesPage from "@/views/pages/history/index.vue";
import CheckPage from "@/views/pages/checking/index.vue";
import store from "@/store/index";

Vue.use(VueRouter);

const baseRouter: Array<RouteConfig> = [
  {
    path: "/login",
    name: "login",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    meta: {
      pageTitle: "Check login",
    },
    component: LoginPage,
  },
  {
    path: "/logout",
    name: "logout",
    component: () => import("../views/pages/logout.vue"),
  },
  {
    path: "/error",
    name: "error",
    component: () => import("../views/pages/error.vue"),
    meta: {
      pageTitle: "ERROR",
      title: "ERROR"
    }
  },
  {
    path: "/",
    name: "",
    component: Layout,
    meta: {
      allowRole: [],
    },
    children: [
      {
        path: "menu",
        name: "menu",
        component: MenuListPage,
        meta: {
          pageTitle: "メニュー",
          title: "メニュー",
          subTitle: "メニュー",
          className: "",
        },
      },
      {
        path: "recommendations",
        name: "recommendations",
        component: RecommendationsPage,
        meta: {
          pageTitle: "おすすめ",
          title: "おすすめ",
          subTitle: "おすすめ",
          className: "",
        },
      },
      {
        path: "order-histories",
        name: "histories",
        component: OrderHistoriesPage,
        meta: {
          pageTitle: "注文履歴",
          title: "注文履歴",
          subTitle: "注文履歴",
          className: "",
        },
      },
      {
        path: "check",
        name: "check",
        component: CheckPage,
        meta: {
          pageTitle: "お会計",
          title: "お会計",
          subTitle: "お会計",
          className: "",
        },
      },
      {
        path: "verify",
        name: "verify",
        meta: {
          className: "",
        },
      },
    ]
  },
  {
    path: "/accounting",
    name: "locked",
    component: () => import("../views/pages/accounting.vue"),
    meta: {
      pageTitle: "locked",
      title: "locked"
    }
  },
];

const routes = [...baseRouter];

const router = new VueRouter({
  mode: "history",
  // base: process.env.NODE_ENV === "development" ? process.env.BASE_URL : "",
  routes,
});

router.beforeEach(async (to, from, next) => {
  const system = store.state.SystemStore.system;
  if ((to.name != "login" && to.name != "error") && !system) {
    next({
      name: "login",
    });
  } else {
    next();
  }
});

router.afterEach((to) => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  Vue.nextTick(() => {
    document.title = to.meta.pageTitle || "";
  });
});
export default router;
